import React, { useState, useEffect, useLayoutEffect } from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  ActivityIndicator,
  FlatList,
  Alert,
  TouchableOpacity,
  Modal,
  Linking,
  Platform,
} from 'react-native';
import {
  addDoc,
  collection,
  onSnapshot,
  query,
  where,
  updateDoc,
  doc,
  getDoc,
  deleteDoc,
  setDoc, // 👈 IMPORTADO
} from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';
import { useNavigation } from '@react-navigation/native';
import SlideMenu from './SlideMenu';
import { MaterialCommunityIcons, MaterialIcons, Ionicons } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';

const CompanyOrderScreen = () => {
  const [companyPhone, setCompanyPhone] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyCEP, setCompanyCEP] = useState('');
  const [companyCNPJ, setCompanyCNPJ] = useState('');
  const [setorValue, setSetorValue] = useState('6.00');
  const [extraValue, setExtraValue] = useState('12,00');
  const [bairroValue, setBairroValue] = useState('9.00');
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [companyLoaded, setCompanyLoaded] = useState(false);
  const [description, setDescription] = useState('');
  const [deliveryLocation, setDeliveryLocation] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [orderValue, setOrderValue] = useState('');
  const [locationType, setLocationType] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [cardType, setCardType] = useState('');
  const [changeValue, setChangeValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [pendingOrders, setPendingOrders] = useState([]);
  const [acceptedOrders, setAcceptedOrders] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [view, setView] = useState('createOrder');
  const [menuVisible, setMenuVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('Pedidos');
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [onlineMotoboys, setOnlineMotoboys] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [motoboyId, setMotoboyId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [unreadMessages, setUnreadMessages] = useState({});
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [messages, setMessages] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(0);

  const navigation = useNavigation();

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: false,
    });
  }, [navigation]);

  // === CHAT EFFECT 1 (alerta web) ===
  useEffect(() => {
    if (!orderId || !motoboyId || !companyId) {
      console.warn('orderId, motoboyId ou companyId estão indefinidos');
      return;
    }

    let previousUnreadCount = 0;
    const chatRef = doc(db, 'chats', orderId);

    const initializeChat = async () => {
      try {
        const snapshot = await getDoc(chatRef);
        if (!snapshot.exists()) {
          await setDoc(chatRef, {
            messages: [],
            orderId,
            participants: [motoboyId, companyId],
          });
        }
      } catch (error) {
        console.error('Erro ao inicializar o chat:', error);
      }
    };

    initializeChat();

    const unsubscribe = onSnapshot(chatRef, (snapshot) => {
      if (!snapshot.exists()) return;

      const data = snapshot.data() || {};
      const newMessages = data.messages || [];
      setMessages(newMessages);

      const currentUserId = auth.currentUser?.uid;
      const unreadCount = newMessages.filter(
        (msg) =>
          msg.senderId !== currentUserId &&
          (!msg.readBy || !msg.readBy.includes(currentUserId))
      ).length;

      if (unreadCount > previousUnreadCount && Platform.OS === 'web') {
        window.alert('Nova mensagem do Motoboy!');
      }

      setUnreadMessages((prev) => ({
        ...prev,
        [orderId]: unreadCount,
      }));
      setHasUnreadMessages(unreadCount > 0);

      previousUnreadCount = unreadCount;
    });

    return () => unsubscribe();
  }, [orderId, motoboyId, companyId]);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      await AsyncStorage.removeItem('email');
      await AsyncStorage.removeItem('password');
      await AsyncStorage.setItem('remember', 'false');

      navigation.reset({
        index: 0,
        routes: [{ name: 'LoginScreen' }],
      });
    } catch (error) {
      console.error('Erro ao deslogar:', error);
      Alert.alert('Erro', 'Não foi possível sair. Tente novamente.');
    }
  };

  useEffect(() => {
    const fetchCompanyData = async () => {
      setLoadingProfile(true);
      try {
        const companyRef = doc(db, 'usuarios', auth.currentUser.uid);
        const docSnap = await getDoc(companyRef);
        if (docSnap.exists()) {
          const companyData = docSnap.data();
          if (companyData.tipo === 'empresa') {
            setCompanyPhone(companyData.phone || 'Telefone não disponível');
            setCompanyName(companyData.companyName || 'Nome da Empresa');
            setCompanyAddress(
              `${companyData.street || 'Rua não disponível'}, ${
                companyData.number || 'Nº não disponível'
              }`
            );
            setCompanyCEP(companyData.cep || 'CEP não disponível');
            setSetorValue(formatCurrency(companyData.setorValue || '6,00'));
            setBairroValue(formatCurrency(companyData.bairroValue || '9,00'));
            setCompanyCNPJ(companyData.cnpj || 'CNPJ não disponível');
            setCompanyLoaded(true);
          }
        }
      } catch (error) {
        console.log('Erro ao buscar dados da empresa: ', error);
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchCompanyData();
  }, []);

  useEffect(() => {
    const q = query(
      collection(db, 'usuarios'),
      where('tipo', '==', 'motoboy'),
      where('isOnline', '==', true)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setOnlineMotoboys(snapshot.docs.length);
    });

    return () => unsubscribe();
  }, []);

  // === CHAT EFFECT 2 (controle de não lidas) ===
  useEffect(() => {
    if (!orderId || !motoboyId || !companyId) {
      console.warn('orderId, motoboyId ou companyId estão indefinidos');
      return;
    }

    const chatRef = doc(db, 'chats', orderId);

    const initializeChat = async () => {
      try {
        const snapshot = await getDoc(chatRef);
        if (!snapshot.exists()) {
          await setDoc(chatRef, {
            messages: [],
            orderId,
            participants: [motoboyId, companyId],
          });
        }
      } catch (error) {
        console.error('Erro ao inicializar o chat:', error);
      }
    };

    initializeChat();

    const unsubscribe = onSnapshot(chatRef, async (snapshot) => {
      if (!snapshot.exists()) return;

      const data = snapshot.data() || {};
      const newMessages = data.messages || [];
      setMessages(newMessages);

      const currentUserId = auth.currentUser?.uid;
      const unreadCount = newMessages.filter(
        (msg) =>
          msg.senderId !== currentUserId &&
          (!msg.readBy || !msg.readBy.includes(currentUserId))
      ).length;

      setUnreadMessages((prev) => ({
        ...prev,
        [orderId]: unreadCount,
      }));

      setHasUnreadMessages(unreadCount > 0);
    });

    return () => unsubscribe();
  }, [orderId, motoboyId, companyId]);

  useEffect(() => {
    if (messages.length > 0) {
      setHasUnreadMessages(false);
    }
  }, [messages]);

  useEffect(() => {
    const fetchUnreadMessages = () => {
      const unsubscribes = [];

      acceptedOrders.forEach((order) => {
        const chatRef = doc(db, 'chats', order.id);

        const unsubscribe = onSnapshot(chatRef, (snapshot) => {
          if (snapshot.exists()) {
            const messages = snapshot.data().messages || [];
            const unreadCount = messages.filter(
              (msg) =>
                msg.senderId !== auth.currentUser.uid &&
                (!msg.readBy || !msg.readBy.includes(auth.currentUser.uid))
            ).length;

            setUnreadMessages((prev) => ({
              ...prev,
              [order.id]: unreadCount,
            }));
          }
        });

        unsubscribes.push(unsubscribe);
      });

      return unsubscribes;
    };

    const unsubscribeListeners = fetchUnreadMessages();

    return () => {
      if (unsubscribeListeners) unsubscribeListeners.forEach((unsub) => unsub());
    };
  }, [acceptedOrders]);

  useEffect(() => {
    const user = auth.currentUser;

    if (!user) {
      console.error('Usuário não autenticado.');
      return;
    }

    const qPending = query(
      collection(db, 'pedidos'),
      where('status', 'in', ['created', 'pending']),
      where('companyId', '==', user.uid)
    );

    const qRoutes = query(
      collection(db, 'routes'),
      where('status', 'in', ['created', 'pending']),
      where('companyId', '==', user.uid)
    );

    const qAccepted = query(
      collection(db, 'pedidos'),
      where('status', '==', 'accepted'),
      where('companyId', '==', user.uid)
    );

    const qAcceptedRoutes = query(
      collection(db, 'routes'),
      where('status', '==', 'accepted'),
      where('companyId', '==', user.uid)
    );

    const qCompleted = query(
      collection(db, 'pedidos'),
      where('status', '==', 'completed'),
      where('companyId', '==', user.uid)
    );

    const qRoutesCompleted = query(
      collection(db, 'routes'),
      where('status', '==', 'completed'),
      where('companyId', '==', user.uid)
    );

    const unsubscribePending = onSnapshot(
      qPending,
      (snapshot) => {
        const pendingArray = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          type: 'order',
        }));
        setPendingOrders(pendingArray);
      },
      (error) => console.error('Erro ao buscar pedidos pendentes:', error.message)
    );

    const unsubscribeRoutes = onSnapshot(
      qRoutes,
      (snapshot) => {
        const routesArray = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          type: 'route',
        }));
        setRoutes(routesArray);
      },
      (error) => console.error('Erro ao buscar rotas pendentes:', error.message)
    );

    const unsubscribeAccepted = onSnapshot(
      qAccepted,
      (snapshot) => {
        const acceptedArray = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          type: 'order',
        }));
        setPendingOrders((prev) =>
          prev.filter((order) => !acceptedArray.some((acc) => acc.id === order.id))
        );
        setAcceptedOrders(acceptedArray);
      },
      (error) => console.error('Erro ao buscar pedidos aceitos:', error.message)
    );

    const unsubscribeAcceptedRoutes = onSnapshot(
      qAcceptedRoutes,
      (snapshot) => {
        const acceptedRoutesArray = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          type: 'route',
        }));
        setRoutes((prev) =>
          prev.filter((route) => !acceptedRoutesArray.some((acc) => acc.id === route.id))
        );
        setAcceptedOrders((prevOrders) => [...prevOrders, ...acceptedRoutesArray]);
      },
      (error) => console.error('Erro ao buscar rotas aceitas:', error.message)
    );

    const unsubscribeCompleted = onSnapshot(
      qCompleted,
      (snapshot) => {
        const completedArray = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          type: 'order',
          completedAtFormatted: doc.data().completedAt
            ? new Date(doc.data().completedAt.seconds * 1000).toLocaleString('pt-BR')
            : null,
        }));
        setAcceptedOrders((prevOrders) =>
          prevOrders.filter((order) =>
            !completedArray.some((completedOrder) => completedOrder.id === order.id)
          )
        );
        setCompletedOrders((prevOrders) => [...prevOrders, ...completedArray]);
      },
      (error) => console.error('Erro ao buscar pedidos concluídos:', error.message)
    );

    const unsubscribeRoutesCompleted = onSnapshot(
      qRoutesCompleted,
      (snapshot) => {
        const routesArray = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          type: 'route',
          completedAtFormatted: doc.data().completedAt
            ? new Date(doc.data().completedAt.seconds * 1000).toLocaleString('pt-BR')
            : null,
        }));
        setAcceptedOrders((prevOrders) =>
          prevOrders.filter((route) =>
            !routesArray.some((completedRoute) => completedRoute.id === route.id)
          )
        );
        setCompletedOrders((prevOrders) => [...prevOrders, ...routesArray]);
      },
      (error) => console.error('Erro ao buscar rotas concluídas:', error.message)
    );

    return () => {
      unsubscribePending();
      unsubscribeRoutes();
      unsubscribeAccepted();
      unsubscribeAcceptedRoutes();
      unsubscribeCompleted();
      unsubscribeRoutesCompleted();
    };
  }, []);

  const handleSaveProfile = async () => {
    if (
      !companyName.trim() ||
      !companyPhone.trim() ||
      !companyAddress.trim() ||
      !companyCEP.trim()
    ) {
      Alert.alert('Erro', 'Todos os campos editáveis do perfil são obrigatórios.');
      return;
    }

    setLoadingProfile(true);
    try {
      const user = auth.currentUser;
      const companyDocRef = doc(db, 'usuarios', user.uid);

      await updateDoc(companyDocRef, {
        companyName: companyName.trim(),
        phone: companyPhone.trim(),
        street: companyAddress.split(',')[0].trim(),
        number: companyAddress.split(',')[1]?.trim() || '',
        cep: companyCEP.trim(),
      });

      setIsEditingProfile(false);
      Alert.alert('Sucesso', 'Perfil da empresa atualizado com sucesso!');
    } catch (error) {
      Alert.alert('Erro', 'Não foi possível atualizar o perfil da empresa.');
    } finally {
      setLoadingProfile(false);
    }
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const str = value.toString();
    const numericValue = parseFloat(str.replace(',', '.'));
    if (isNaN(numericValue)) return '';
    return numericValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const parseCurrency = (value) => {
    if (!value) return 0;

    let v = value.toString().trim();
    v = v.replace(/[^\d.,]/g, '');

    if (v.includes(',')) {
      v = v.replace(/\./g, '');
      v = v.replace(',', '.');
    }

    const num = parseFloat(v);
    return isNaN(num) ? 0 : num;
  };

  // ===== HANDLER PARA CAMPOS DE MOEDA =====
  const handleCurrencyChange = (setter) => (text) => {
    if (!text) {
      setter('');
      return;
    }

    // mantém apenas dígitos, vírgula e ponto
    let clean = text.replace(/[^\d.,]/g, '');

    // converte todos os pontos para vírgula (visual BR)
    clean = clean.replace(/\./g, ',');

    // garante só UMA vírgula
    const parts = clean.split(',');
    if (parts.length > 2) {
      clean = parts[0] + ',' + parts.slice(1).join('');
    }

    setter(clean);
  };

  const handleCreateOrder = () => {
    if (!companyLoaded) {
      Alert.alert('Erro', 'Os dados da empresa ainda não foram carregados.');
      return;
    }
    setConfirmationVisible(true);
  };

  const confirmCreateOrder = async () => {
    if (
      !description ||
      !deliveryLocation ||
      !clientName ||
      !clientPhone ||
      !orderValue ||
      !locationType ||
      !paymentMethod ||
      (paymentMethod === 'cartao' && !cardType) ||
      (paymentMethod === 'dinheiro' && !changeValue)
    ) {
      Platform.OS === 'web'
        ? window.alert('Por favor, preencha todos os campos e escolha as opções de pagamento.')
        : Alert.alert('Erro', 'Por favor, preencha todos os campos e escolha as opções de pagamento.');
      return;
    }

    const numericOrderValue = parseCurrency(orderValue);

    if (isNaN(numericOrderValue)) {
      Platform.OS === 'web'
        ? window.alert('O valor do pedido deve ser um número válido.')
        : Alert.alert('Erro', 'O valor do pedido deve ser um número válido.');
      return;
    }

    let locationValue = 0;

    if (locationType === 'Setor') {
      locationValue = parseCurrency(setorValue);
    } else if (locationType === 'Bairro') {
      locationValue = parseCurrency(bairroValue);
    } else if (locationType === 'Extra') {
      locationValue = parseCurrency(extraValue);
    }

    if (paymentMethod === 'cartao') {
      if (locationType === 'Setor') {
        locationValue *= 1.25;
      } else if (locationType === 'Bairro') {
        locationValue = 12.0;
      } else if (locationType === 'Extra') {
        locationValue *= 1.25;
      }
    }

    setLoading(true);
    setErrorMessage('');
    try {
      const user = auth.currentUser;
      const companyDocRef = doc(db, 'usuarios', user.uid);
      const companyDoc = await getDoc(companyDocRef);

      if (!companyDoc.exists()) {
        Platform.OS === 'web'
          ? window.alert('Dados da empresa não encontrados.')
          : Alert.alert('Erro', 'Dados da empresa não encontrados.');
        setLoading(false);
        return;
      }

      const companyData = companyDoc.data();
      const companyName = companyData.companyName || 'Nome da Empresa';
      const companyAddress = `${companyData.street || 'Rua não disponível'}, ${
        companyData.number || 'Nº não disponível'
      }, ${companyData.cep || 'CEP não disponível'}`;
      const companyPhone = companyData.phone || 'Telefone não disponível';

      const verificationCode = Math.floor(1000 + Math.random() * 9000).toString();

      const newOrderData = {
        description,
        deliveryLocation,
        clientName,
        clientPhone,
        orderValue: numericOrderValue,
        locationType,
        locationValue: locationValue.toFixed(2),
        paymentMethod,
        cardType,
        changeValue:
          paymentMethod === 'dinheiro'
            ? parseCurrency(changeValue).toFixed(2)
            : null,
        companyName,
        companyAddress,
        companyPhone,
        verificationCode,
        createdAt: new Date(),
        companyId: user.uid,
      };

      if (editingOrderId) {
        const orderDocRef = doc(db, 'pedidos', editingOrderId);
        const orderDoc = await getDoc(orderDocRef);

        if (!orderDoc.exists()) {
          throw new Error('Pedido não encontrado para atualização.');
        }

        const existingOrderData = orderDoc.data();
        const updatedOrder = {
          ...existingOrderData,
          ...newOrderData,
          status: existingOrderData.status,
          motoboyId: existingOrderData.motoboyId || null,
          motoboyName: existingOrderData.motoboyName || null,
        };

        await updateDoc(orderDocRef, updatedOrder);
        setEditingOrderId(null);
        Platform.OS === 'web'
          ? window.alert('Pedido atualizado com sucesso!')
          : Alert.alert('Sucesso', 'Pedido atualizado com sucesso!');
      } else {
        await addDoc(collection(db, 'pedidos'), {
          ...newOrderData,
          status: 'created',
        });
        Platform.OS === 'web'
          ? window.alert(
              `Pedido criado com sucesso! Código de verificação: ${verificationCode}`
            )
          : Alert.alert(
              'Sucesso',
              `Pedido criado com sucesso! Código de verificação: ${verificationCode}`
            );
      }

      setDescription('');
      setDeliveryLocation('');
      setClientName('');
      setClientPhone('');
      setOrderValue('');
      setLocationType('');
      setPaymentMethod('');
      setCardType('');
      setChangeValue('');
      setView('pending');
    } catch (error) {
      console.error('Erro ao criar ou atualizar pedido:', error.message);
      Platform.OS === 'web'
        ? window.alert('Erro ao processar pedido: ' + error.message)
        : Alert.alert('Erro ao processar pedido: ' + error.message);
    } finally {
      setLoading(false);
      setConfirmationVisible(false);
    }
  };

  const handleDeleteOrder = async (orderId) => {
    const confirmed =
      Platform.OS === 'web'
        ? window.confirm('Tem certeza que deseja cancelar este pedido?')
        : null;

    if (Platform.OS !== 'web') {
      Alert.alert(
        'Confirmação',
        'Tem certeza que deseja cancelar este pedido?',
        [
          { text: 'Não', style: 'cancel' },
          { text: 'Sim', onPress: () => deleteOrder(orderId) },
        ],
        { cancelable: false }
      );
      return;
    }

    if (confirmed) {
      try {
        const orderRef = doc(db, 'pedidos', orderId);
        await updateDoc(orderRef, {
          status: 'cancelled',
        });

        alert('Pedido cancelado com sucesso!');
        await deleteDoc(orderRef);
      } catch (error) {
        console.error('Erro ao cancelar o pedido:', error.message);
        alert('Erro ao cancelar o pedido. Tente novamente.');
      }
    }
  };

  const deleteOrder = async (orderId) => {
    try {
      await deleteDoc(doc(db, 'pedidos', orderId));
      Alert.alert('Sucesso', 'Pedido cancelado com sucesso!');
    } catch (error) {
      console.error('Erro ao cancelar o pedido:', error);
      Alert.alert('Erro', 'Não foi possível cancelar o pedido.');
    }
  };

  const handleCancelRoute = async (routeId) => {
    const confirmed =
      Platform.OS === 'web'
        ? window.confirm('Tem certeza que deseja cancelar esta rota?')
        : await new Promise((resolve) => {
            Alert.alert(
              'Confirmação',
              'Tem certeza que deseja cancelar esta rota?',
              [
                { text: 'Não', style: 'cancel', onPress: () => resolve(false) },
                { text: 'Sim', onPress: () => resolve(true) },
              ],
              { cancelable: false }
            );
          });

    if (!confirmed) return;

    try {
      const routeRef = doc(db, 'routes', routeId);
      await deleteDoc(routeRef);

      setRoutes((prevRoutes) => prevRoutes.filter((route) => route.id !== routeId));
      Alert.alert('Sucesso', 'Rota cancelada com sucesso!');
    } catch (error) {
      console.error('Erro ao cancelar a rota:', error.message);
      Alert.alert('Erro', 'Não foi possível cancelar a rota. Tente novamente.');
    }

    try {
      await deleteDoc(doc(db, 'routes', routeId));
      setAcceptedOrders((prevOrders) =>
        prevOrders.filter((order) => order.id !== routeId)
      );
      setForceUpdate((prev) => prev + 1);
      Alert.alert('Sucesso', 'Rota cancelada com sucesso!');
    } catch (error) {
      // silencioso
    }
  };

  const handleEditOrder = (order) => {
    setDescription(order.description);
    setDeliveryLocation(order.deliveryLocation);
    setClientName(order.clientName);
    setClientPhone(order.clientPhone);
    setOrderValue(order.orderValue.toString());
    setLocationType(order.locationType);
    setPaymentMethod(order.paymentMethod || '');
    setCardType(order.cardType || '');
    setChangeValue(order.changeValue ? order.changeValue.toString() : '');
    setEditingOrderId(order.id);
    setView('createOrder');
  };

  const handleCallDelivery = async (orderId) => {
    try {
      const orderRef = doc(db, 'pedidos', orderId);
      await updateDoc(orderRef, {
        status: 'pending',
      });
      Alert.alert('Sucesso', 'O pedido foi enviado para os motoboys.');
    } catch (error) {
      console.error('Erro ao chamar o motoboy:', error);
      Alert.alert('Erro', 'Não foi possível enviar o pedido para os motoboys.');
    }
  };

  const renderOrderItem = ({ item }) => {
    let locationCost = '';
    if (item.locationType === 'Setor') {
      locationCost = `R$ ${formatCurrency(item.locationValue || setorValue)}`;
    } else if (item.locationType === 'Bairro') {
      locationCost = `R$ ${formatCurrency(item.locationValue || bairroValue)}`;
    } else if (item.locationType === 'Extra') {
      locationCost = `R$ ${formatCurrency(item.locationValue || extraValue)}`;
    }

    return (
      <View style={styles.orderCard}>
        <View style={styles.orderCardContent}>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Descrição:</Text> {item.description}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Local de Entrega:</Text> {item.deliveryLocation}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Cliente:</Text> {item.clientName}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Telefone:</Text> {item.clientPhone}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Valor do Pedido:</Text> R${' '}
            {formatCurrency(item.orderValue.toString())}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Tipo de Localização:</Text> {item.locationType}{' '}
            {locationCost}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Código de Verificação:</Text>{' '}
            {item.verificationCode}
          </Text>
          <Text style={styles.orderText}>
            <Text style={styles.label}>Forma de Pagamento:</Text> {item.paymentMethod}
          </Text>
          {item.paymentMethod === 'cartao' && (
            <Text style={styles.orderText}>
              <Text style={styles.label}>Tipo de Cartão:</Text> {item.cardType}
            </Text>
          )}
          {item.paymentMethod === 'dinheiro' && item.changeValue && (
            <Text style={styles.orderText}>
              <Text style={styles.label}>Troco para:</Text> R${' '}
              {formatCurrency(item.changeValue)}
            </Text>
          )}
          {item.completedAtFormatted && (
            <Text style={styles.orderText}>
              <Text style={styles.label}>Finalizado em:</Text>{' '}
              {item.completedAtFormatted}
            </Text>
          )}
          {item.motoboyName && (
            <>
              <Text style={styles.orderText}>
                <Text style={styles.label}>Motoboy:</Text> {item.motoboyName}
              </Text>
              <Text style={styles.orderText}>
                <Text style={styles.label}>Telefone do Motoboy:</Text>{' '}
                {item.motoboyPhone}
              </Text>
              <Text style={styles.orderText}>
                <Text style={styles.label}>Placa da Moto:</Text> {item.motoboyPlate}
              </Text>
            </>
          )}
        </View>

        <View style={styles.orderCardFooter}>
          {item.status !== 'completed' && (
            <View style={styles.buttonRow}>
              <TouchableOpacity
                style={[styles.button, styles.cancelButton]}
                onPress={() => handleDeleteOrder(item.id)}
              >
                <Text style={styles.cancelButtonText}>Cancelar</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.button, styles.editButton]}
                onPress={() => handleEditOrder(item)}
              >
                <Text style={styles.editButtonText}>Alterar</Text>
              </TouchableOpacity>
              {item.status === 'created' && (
                <TouchableOpacity
                  style={[styles.button, styles.callButton]}
                  onPress={() => handleCallDelivery(item.id)}
                >
                  <Text style={styles.callButtonText}>Chamar motoboy</Text>
                </TouchableOpacity>
              )}
              {item.status === 'accepted' && (
                <TouchableOpacity
                  style={[styles.button, styles.chatButton]}
                  onPress={() => {
                    setHasUnreadMessages(false);
                    navigation.navigate('Chat', {
                      orderId: item.id,
                      companyId: item.companyId,
                      motoboyId: item.motoboyId,
                    });
                  }}
                >
                  <Ionicons
                    name="chatbubble-ellipses-outline"
                    size={20}
                    color="#FFF"
                  />
                  {unreadMessages[item.id] > 0 && (
                    <View style={styles.notificationBadge}>
                      <Text style={styles.notificationText}>
                        {unreadMessages[item.id]}
                      </Text>
                    </View>
                  )}
                  <Text style={styles.chatButtonText}>Chat</Text>
                </TouchableOpacity>
              )}
            </View>
          )}
        </View>
      </View>
    );
  };

  const renderRouteItem = ({ item }) => (
    <View style={styles.orderCard}>
      <View style={styles.orderCardContent}>
        <Text style={styles.orderText}>
          <Text style={styles.label}>Valor Total da Rota:</Text> R${' '}
          {parseFloat(item.totalValue || 0)
            .toFixed(2)
            .replace('.', ',')}
        </Text>

        {item.motoboyName && (
          <>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Motoboy:</Text>{' '}
              {item.motoboyName || 'Nome não disponível'}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Telefone do Motoboy:</Text>{' '}
              {item.motoboyPhone || 'Telefone não disponível'}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Placa da Moto:</Text>{' '}
              {item.motoboyPlate || 'Placa não disponível'}
            </Text>
          </>
        )}

        {item.orders.map((order, index) => (
          <View key={index} style={styles.orderInRoute}>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Descrição:</Text> {order.description}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Local de Entrega:</Text>{' '}
              {order.deliveryLocation}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Cliente:</Text> {order.clientName}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Telefone:</Text> {order.clientPhone}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Valor do Pedido:</Text> R${' '}
              {parseFloat(order.orderValue || 0)
                .toFixed(2)
                .replace('.', ',')}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Tipo de Localização:</Text>{' '}
              {order.locationType}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Código de Verificação:</Text>{' '}
              {order.verificationCode}
            </Text>
            <Text style={styles.orderText}>
              <Text style={styles.label}>Forma de Pagamento:</Text>{' '}
              {order.paymentMethod}
            </Text>
            {order.paymentMethod === 'cartao' && (
              <Text style={styles.orderText}>
                <Text style={styles.label}>Tipo de Cartão:</Text>{' '}
                {order.cardType}
              </Text>
            )}
            {order.paymentMethod === 'dinheiro' && order.changeValue && (
              <Text style={styles.orderText}>
                <Text style={styles.label}>Troco para:</Text> R${' '}
                {parseFloat(order.changeValue)
                  .toFixed(2)
                  .replace('.', ',')}
              </Text>
            )}
          </View>
        ))}

        {item.completedAtFormatted && (
          <Text style={styles.orderText}>
            <Text style={styles.label}>Finalizado em:</Text>{' '}
            {item.completedAtFormatted}
          </Text>
        )}
      </View>

      <View style={styles.orderCardFooter}>
        {item.status !== 'completed' && (
          <TouchableOpacity
            style={styles.cancelButton}
            onPress={() => handleCancelRoute(item.id)}
          >
            <Text style={styles.cancelButtonText}>Cancelar</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );

  const handleSupportClick = () => {
    const phoneNumber = '5561995998395';
    const message = 'Olá, gostaria de suporte !';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    Linking.openURL(url).catch(() => {
      alert('Não foi possível abrir o WhatsApp.');
    });
  };

  return (
    <View style={styles.container}>
      <SlideMenu navigation={navigation} setView={setView} acceptedOrders={acceptedOrders} />

      <View style={styles.headerButtonsContainer}>
        <TouchableOpacity style={styles.logoutButton} onPress={handleLogout}>
          <MaterialIcons name="logout" size={24} color="#00FF9D" />
        </TouchableOpacity>
      </View>

      {view === 'createOrder' && (
        <View style={styles.createOrderContainer}>
          <Text style={styles.title}>Criar Novo Pedido</Text>
          {errorMessage ? <Text style={styles.errorText}>{errorMessage}</Text> : null}

          <View style={styles.inputContainerOrder}>
            <MaterialIcons name="description" size={24} color="#FFF" />
            <TextInput
              placeholder="Descrição do Pedido"
              placeholderTextColor="#aaa"
              value={description}
              onChangeText={setDescription}
              style={styles.inputText}
            />
          </View>

          <View style={styles.inputContainerOrder}>
            <MaterialIcons name="location-on" size={24} color="#FFF" />
            <TextInput
              placeholder="Local de Entrega"
              placeholderTextColor="#aaa"
              value={deliveryLocation}
              onChangeText={setDeliveryLocation}
              style={styles.inputText}
            />
          </View>

          <View style={styles.inputContainerOrder}>
            <MaterialIcons name="person" size={24} color="#FFF" />
            <TextInput
              placeholder="Nome do Cliente"
              placeholderTextColor="#aaa"
              value={clientName}
              onChangeText={setClientName}
              style={styles.inputText}
            />
          </View>

          <View style={styles.inputContainerOrder}>
            <MaterialIcons name="phone" size={24} color="#FFF" />
            <TextInput
              placeholder="Telefone do Cliente"
              placeholderTextColor="#aaa"
              value={clientPhone}
              onChangeText={(text) => {
                const onlyDigits = text.replace(/\D/g, '');
                setClientPhone(onlyDigits);
              }}
              keyboardType="phone-pad"
              style={styles.inputText}
            />
          </View>

          <View style={styles.inputContainerOrder}>
            <MaterialIcons name="attach-money" size={24} color="#FFF" />
            <TextInput
              placeholder="Valor do Pedido"
              placeholderTextColor="#aaa"
              value={orderValue}
              onChangeText={handleCurrencyChange(setOrderValue)}
              keyboardType="decimal-pad"
              style={styles.inputText}
            />
          </View>

          <View style={styles.buttonGroup}>
            <TouchableOpacity
              style={[
                styles.choiceButton,
                locationType === 'Setor' && styles.selectedButton,
              ]}
              onPress={() => setLocationType('Setor')}
            >
              <Text
                style={[
                  styles.choiceButtonText,
                  locationType === 'Setor' && styles.selectedButtonText,
                ]}
              >
                Setor
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.choiceButton,
                locationType === 'Bairro' && styles.selectedButton,
              ]}
              onPress={() => setLocationType('Bairro')}
            >
              <Text
                style={[
                  styles.choiceButtonText,
                  locationType === 'Bairro' && styles.selectedButtonText,
                ]}
              >
                Bairro
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.choiceButton,
                locationType === 'Extra' && styles.selectedButton,
              ]}
              onPress={() => setLocationType('Extra')}
            >
              <Text
                style={[
                  styles.choiceButtonText,
                  locationType === 'Extra' && styles.selectedButtonText,
                ]}
              >
                Extra
              </Text>
            </TouchableOpacity>
          </View>

          <View style={styles.buttonGroup}>
            <TouchableOpacity
              style={[
                styles.choiceButton,
                paymentMethod === 'cartao' && styles.selectedButton,
              ]}
              onPress={() => setPaymentMethod('cartao')}
            >
              <Text
                style={[
                  styles.choiceButtonText,
                  paymentMethod === 'cartao' && styles.selectedButtonText,
                ]}
              >
                Cartão
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.choiceButton,
                paymentMethod === 'dinheiro' && styles.selectedButton,
              ]}
              onPress={() => setPaymentMethod('dinheiro')}
            >
              <Text
                style={[
                  styles.choiceButtonText,
                  paymentMethod === 'dinheiro' && styles.selectedButtonText,
                ]}
              >
                Dinheiro
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.choiceButton,
                paymentMethod === 'pix' && styles.selectedButton,
              ]}
              onPress={() => setPaymentMethod('pix')}
            >
              <Text
                style={[
                  styles.choiceButtonText,
                  paymentMethod === 'pix' && styles.selectedButtonText,
                ]}
              >
                Pix
              </Text>
            </TouchableOpacity>
          </View>

          {paymentMethod === 'cartao' && (
            <View style={styles.buttonGroup}>
              <TouchableOpacity
                style={[
                  styles.choiceButton,
                  cardType === 'debito' && styles.selectedButton,
                ]}
                onPress={() => setCardType('debito')}
              >
                <Text
                  style={[
                    styles.choiceButtonText,
                    cardType === 'debito' && styles.selectedButtonText,
                  ]}
                >
                  Débito
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.choiceButton,
                  cardType === 'credito' && styles.selectedButton,
                ]}
                onPress={() => setCardType('credito')}
              >
                <Text
                  style={[
                    styles.choiceButtonText,
                    cardType === 'credito' && styles.selectedButtonText,
                  ]}
                >
                  Crédito
                </Text>
              </TouchableOpacity>
            </View>
          )}

          {paymentMethod === 'dinheiro' && (
            <View style={styles.inputContainerOrder}>
              <MaterialIcons name="attach-money" size={24} color="#FFF" />
              <TextInput
                placeholder="Valor do Troco"
                placeholderTextColor="#aaa"
                value={changeValue}
                onChangeText={handleCurrencyChange(setChangeValue)}
                keyboardType="decimal-pad"
                style={styles.inputText}
              />
            </View>
          )}

          {loading ? (
            <ActivityIndicator size="large" color="#FFF" />
          ) : (
            <TouchableOpacity style={styles.createButton} onPress={confirmCreateOrder}>
              <Text style={styles.createButtonText}>
                {editingOrderId ? 'Alterar Pedido' : 'Criar Pedido'}
              </Text>
            </TouchableOpacity>
          )}
        </View>
      )}

      {view === 'pending' && (
        <View style={styles.orderListContainer}>
          <Text style={styles.listTitleHighlighted}>Pedidos Pendentes</Text>
          <FlatList
            data={pendingOrders}
            keyExtractor={(item) => item.id}
            renderItem={renderOrderItem}
          />
        </View>
      )}

      {view === 'accepted' && (
        <View style={styles.orderListContainer}>
          <Text style={styles.listTitleHighlighted}>Pedidos Aceitos</Text>
          <FlatList
            data={acceptedOrders.filter((item) => item.type === 'order')}
            keyExtractor={(item) => item.id}
            renderItem={renderOrderItem}
          />
        </View>
      )}

      {view === 'completed' && (
        <View style={styles.orderListContainer}>
          <Text style={styles.listTitleHighlighted}>Histórico de Pedidos</Text>
          <FlatList
            data={[...completedOrders]
              .filter((item) => item.type === 'order')
              .sort(
                (a, b) =>
                  (b.completedAt?.seconds || 0) - (a.completedAt?.seconds || 0)
              )}
            keyExtractor={(item) => item.id}
            renderItem={renderOrderItem}
          />
        </View>
      )}

      {view === 'profile' && (
        <View style={styles.profileContainer}>
          <Text style={styles.title}>Perfil da Empresa</Text>

          {loadingProfile ? (
            <ActivityIndicator size="large" color="#FFF" />
          ) : (
            <>
              <View style={styles.inputContainer}>
                <MaterialIcons name="business" size={24} color="#FFF" />
                <TextInput
                  placeholder="Nome da Empresa"
                  placeholderTextColor="#CCC"
                  value={companyName}
                  onChangeText={setCompanyName}
                  style={styles.input}
                  editable={isEditingProfile}
                />
              </View>

              <View style={styles.inputContainer}>
                <MaterialIcons name="phone" size={24} color="#FFF" />
                <TextInput
                  placeholder="Telefone da Empresa"
                  placeholderTextColor="#CCC"
                  value={companyPhone}
                  onChangeText={setCompanyPhone}
                  keyboardType="phone-pad"
                  style={styles.input}
                  editable={isEditingProfile}
                />
              </View>

              <View style={styles.inputContainer}>
                <MaterialIcons name="location-city" size={24} color="#FFF" />
                <TextInput
                  placeholder="Endereço da Empresa"
                  placeholderTextColor="#CCC"
                  value={companyAddress}
                  onChangeText={setCompanyAddress}
                  style={styles.input}
                  editable={isEditingProfile}
                />
              </View>

              <View style={styles.inputContainer}>
                <MaterialIcons name="markunread-mailbox" size={24} color="#FFF" />
                <TextInput
                  placeholder="CEP"
                  placeholderTextColor="#CCC"
                  value={companyCEP}
                  onChangeText={setCompanyCEP}
                  keyboardType="numeric"
                  style={styles.input}
                  editable={isEditingProfile}
                />
              </View>

              <View style={styles.fixedValueContainer}>
                <Text style={styles.fixedValueLabel}>Valor do Setor:</Text>
                <Text style={styles.fixedValueText}>R$ {setorValue}</Text>
              </View>

              <View style={styles.fixedValueContainer}>
                <Text style={styles.fixedValueLabel}>Valor do Bairro:</Text>
                <Text style={styles.fixedValueText}>R$ {bairroValue}</Text>
              </View>

              <View style={styles.fixedValueContainer}>
                <Text style={styles.fixedValueLabel}>Valor Extra:</Text>
                <Text style={styles.fixedValueText}>R$ {extraValue}</Text>
              </View>

              {isEditingProfile ? (
                <TouchableOpacity style={styles.saveButton} onPress={handleSaveProfile}>
                  <Text style={styles.saveButtonText}>Salvar Alterações</Text>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity
                  style={styles.editButton}
                  onPress={() => setIsEditingProfile(true)}
                >
                  <Text style={styles.editButtonText}>Editar Perfil</Text>
                </TouchableOpacity>
              )}
            </>
          )}
        </View>
      )}

      <Modal
        visible={confirmationVisible}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setConfirmationVisible(false)}
      >
        <View style={styles.confirmationModal}>
          <Text style={styles.confirmationText}>Deseja criar este pedido?</Text>
          <View style={styles.confirmationButtons}>
            <TouchableOpacity
              style={styles.confirmationButton}
              onPress={confirmCreateOrder}
            >
              <Text style={styles.confirmationButtonText}>Confirmar</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.confirmationButton}
              onPress={() => setConfirmationVisible(false)}
            >
              <Text style={styles.confirmationButtonText}>Cancelar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      <View style={styles.motoboyCounterContainer}>
        <Text style={styles.motoboyCounterText}>
          Motoboys Online: {onlineMotoboys}
        </Text>
      </View>

      <TouchableOpacity style={styles.supportButton} onPress={handleSupportClick}>
        <Text style={styles.supportButtonText}>Suporte</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: '#2c5364',
  },
  headerButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    marginTop: Platform.OS === 'web' ? 10 : 40,
  },
  logoutButton: {
    backgroundColor: '#203a43',
    borderRadius: 50,
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 5,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#FFF',
    marginBottom: 20,
    textAlign: 'center',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#2c5364',
    borderRadius: 10,
    paddingHorizontal: 10,
    marginBottom: 15,
    height: 50,
    borderWidth: 1,
    borderColor: '#00FF9D',
  },
  input: {
    flex: 1,
    color: '#FFF',
    fontSize: 16,
    marginLeft: 10,
  },
  saveButton: {
    backgroundColor: '#00FF9D',
    paddingVertical: 12,
    borderRadius: 10,
    alignItems: 'center',
    marginTop: 20,
  },
  saveButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 16,
  },
  buttonGroup: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    width: '90%',
  },
  choiceButton: {
    flex: 1,
    marginHorizontal: 5,
    paddingVertical: 10,
    borderRadius: 10,
    backgroundColor: '#203a43',
  },
  selectedButton: {
    backgroundColor: '#0f2027',
  },
  choiceButtonText: {
    textAlign: 'center',
    color: '#FFF',
  },
  selectedButtonText: {
    color: '#FFF',
  },
  errorText: {
    color: '#FF0000',
    marginBottom: 10,
    textAlign: 'center',
    fontSize: 16,
  },
  order: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: '#FFF',
    padding: 16,
    marginBottom: 12,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 5 },
    elevation: 5,
    borderColor: '#000',
    borderWidth: 1,
  },
  orderText: {
    fontSize: 16,
    color: '#FFF',
    marginBottom: 5,
  },
  orderStatusText: {
    fontSize: 16,
    color: '#ff9800',
    marginBottom: 5,
  },
  cancelButton: {
    backgroundColor: '#FF6347',
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
  },
  cancelButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
  },
  callButton: {
    backgroundColor: '#00FF9D',
  },
  callButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
  },
  editButton: {
    backgroundColor: '#FFD700',
    paddingVertical: 12,
    borderRadius: 10,
    alignItems: 'center',
    marginTop: 20,
  },
  editButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 16,
  },
  profileContainer: {
    flex: 1,
    padding: 20,
    backgroundColor: '#203a43',
    borderRadius: 15,
    margin: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.2,
    shadowRadius: 10,
    elevation: 4,
  },
  supportButton: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    backgroundColor: '#000',
    padding: 10,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  supportButtonText: {
    color: '#FFF',
    fontSize: 16,
  },
  notificationBadge: {
    position: 'absolute',
    top: -5,
    right: -5,
    backgroundColor: 'red',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  notificationText: {
    color: '#FFF',
    fontSize: 12,
    fontWeight: 'bold',
  },
  createOrderContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    backgroundColor: '#2c5364',
  },
  orderListContainer: {
    flex: 1,
  },
  routeContainer: {
    padding: 16,
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 10,
    backgroundColor: '#FFF',
    marginBottom: 10,
  },
  orderInRoute: {
    marginTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#000',
    paddingTop: 10,
  },
  confirmationModal: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: 20,
  },
  confirmationText: {
    fontSize: 18,
    color: '#FFF',
    marginBottom: 20,
    textAlign: 'center',
  },
  confirmationButtons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  confirmationButton: {
    backgroundColor: '#000',
    padding: 10,
    borderRadius: 5,
  },
  confirmationButtonText: {
    color: '#FFF',
    fontSize: 16,
    textAlign: 'center',
  },
  inputContainerOrder: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#203a43',
    borderRadius: 10,
    padding: 10,
    marginBottom: 15,
    width: '90%',
  },
  balloonContainer: {
    backgroundColor: '#2c5364',
    borderRadius: 10,
    padding: 15,
    marginBottom: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.3,
    shadowRadius: 10,
    elevation: 5,
  },
  balloonText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  buttonAction: {
    backgroundColor: '#203a43',
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    marginVertical: 10,
  },
  buttonActionText: {
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 14,
  },
  inputText: {
    flex: 1,
    color: '#FFF',
    fontSize: 16,
    marginLeft: 10,
  },
  createButton: {
    backgroundColor: '#00FF9D',
    paddingVertical: 15,
    borderRadius: 10,
    marginTop: 20,
    width: '90%',
    alignItems: 'center',
  },
  createButtonText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  listTitleHighlighted: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#00FF9D',
  },
  orderCard: {
    backgroundColor: '#203a43',
    borderRadius: 10,
    padding: 15,
    marginBottom: 15,
    shadowColor: '#00FF9D',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 10,
    borderColor: '#00FF9D',
    borderWidth: 2,
  },
  orderCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  orderCardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    marginLeft: 10,
  },
  orderCardContent: {
    marginBottom: 10,
  },
  label: {
    fontWeight: 'bold',
    color: '#FFF',
  },
  orderCardFooter: {
    borderTopWidth: 1,
    borderTopColor: '#2c5364',
    paddingTop: 10,
  },
  button: {
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 15,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fixedValueContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#2c5364',
    borderRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#00FF9D',
  },
  fixedValueLabel: {
    fontSize: 16,
    color: '#FFF',
    fontWeight: 'bold',
  },
  fixedValueText: {
    fontSize: 16,
    color: '#FFF',
  },
  motoboyCounterContainer: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    backgroundColor: '#203a43',
    padding: 10,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.3,
    shadowRadius: 10,
    elevation: 5,
  },
  motoboyCounterText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  chatButton: {
    backgroundColor: '#00FF9D',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 15,
    marginHorizontal: 5,
  },
  chatButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 14,
    marginLeft: 5,
  },
});

export default CompanyOrderScreen;
